import { graphql } from 'gatsby';

import ContactTourSection from 'design-system/src/components/organisms/ContactTourSection';

export default ContactTourSection;

export const query = graphql`
    fragment DatoCmsContactTourSection on DatoCmsContactTourSection {
        iframeUrl
        bannerText
        cta {
            ...Button
        }
        backButton {
            ...Button
        }
        modalTitle
        modalText
        form {
            ...Form
        }
        rating
        ratingLink {
            ...Button
        }
    }
`;
